import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

import Header from './components/Header';
import Footer from './components/Footer';
import RegistrationForm from './components/RegistrationForm';
import LoginForm from './components/LoginForm';
import Dashboard, { ApprovalsDashboard } from './components/Dashboard';
import ManageMembers from './components/ManageMembers';
import AdminEditUserForm from './components/AdminEditUserForm';
import BulkImportPage from './components/BulkImportPage';
import StatisticsDashboard from './components/StatisticsDashboard';
import NotFound from './components/NotFound';
import ProfilePage from './components/ProfilePage';
import UserDashboard from './components/UserDashboard';
import ChangePasswordForm from './components/ChangePasswordForm';
import EditProfileForm from './components/EditProfileForm';
import MemberDirectory from './components/MemberDirectory';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useAuth();
    if (!isAuthenticated) { return <Navigate to="/login" />; }
    return children;
};

// Updated Layout to center content
const MainLayout = ({ children }) => (
    <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex items-center justify-center">
            {children}
        </main>
        <Footer />
    </div>
);

const AdminLayout = ({ children }) => (
     <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
    </div>
)

function App() {
  return (
    <div className="bg-gray-100 font-sans">
      <Router>
        <Routes>
          {/* Public Routes with Main Layout */}
          <Route path="/" element={<MainLayout><MemberDirectory /></MainLayout>} />
          <Route path="/register" element={<MainLayout><RegistrationForm /></MainLayout>} />
          {/* The login route is now inside the main layout for consistency */}
          <Route path="/login" element={<MainLayout><LoginForm /></MainLayout>} />
          <Route path="/member/:memberId" element={<MainLayout><ProfilePage /></MainLayout>} />
          <Route path="/directory" element={<MainLayout><MemberDirectory /></MainLayout>} />
          
          {/* Protected User Routes with Main Layout */}
          <Route path="/my-dashboard" element={<ProtectedRoute><MainLayout><UserDashboard /></MainLayout></ProtectedRoute>} />
          <Route path="/edit-profile" element={<ProtectedRoute><MainLayout><EditProfileForm /></MainLayout></ProtectedRoute>} />
          <Route path="/change-password" element={<ProtectedRoute><MainLayout><ChangePasswordForm /></MainLayout></ProtectedRoute>} />
          {/* Protected Admin Routes with their own layout */}
          <Route 
              path="/portal-management-7a8b9c"
              element={<ProtectedRoute><AdminLayout><Dashboard /></AdminLayout></ProtectedRoute>}
          >
              <Route index element={<Navigate to="stats" replace />} /> 
              <Route path="stats" element={<StatisticsDashboard />} />
              <Route path="approvals" element={<ApprovalsDashboard />} />
              <Route path="manage-members" element={<ManageMembers />} />
              <Route path="edit-user/:userId" element={<AdminEditUserForm />} />
              <Route path="bulk-import" element={<BulkImportPage />} />
          </Route>

          {/* Catch-all for unknown routes */}
          <Route path="*" element={<MainLayout><NotFound /></MainLayout>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;

